export const transactions = [
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "%Closed Loop":2.1,
        "Cash-In Frequency":8,
        "Cash In-Volume (Bn IDR)":151000.0,
        "Cash-Out Frequency":191,
        "Cash-Out Volume (Bn IDR)":300000.0,
        "Posisi Saldo EOM (Bn IDR)":165000.0,
        "Rerata Saldo YTD (Bn IDR)":143000.0,
        "% Cash Out BNI vs Cash Out Total":7.2
    },
    {
        "company_name":"TUDUNG PUTRA PUTRI JAYA",
        "group_company":"GARUDAFOOD",
        "%Closed Loop":1.7,
        "Cash-In Frequency":10,
        "Cash In-Volume (Bn IDR)":5.5,
        "Cash-Out Frequency":90,
        "Cash-Out Volume (Bn IDR)":19.25,
        "Posisi Saldo EOM (Bn IDR)":6.5,
        "Rerata Saldo YTD (Bn IDR)":4.5,
        "% Cash Out BNI vs Cash Out Total":8.9
    },
    {
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "%Closed Loop":3.1,
        "Cash-In Frequency":12,
        "Cash In-Volume (Bn IDR)":13594.0,
        "Cash-Out Frequency":141,
        "Cash-Out Volume (Bn IDR)":47579.0,
        "Posisi Saldo EOM (Bn IDR)":15000.0,
        "Rerata Saldo YTD (Bn IDR)":12000.0,
        "% Cash Out BNI vs Cash Out Total":6.3
    },
    {
        "company_name":"GARUDA TIMUR PACIFIC",
        "group_company":"GARUDAFOOD",
        "%Closed Loop":1.2,
        "Cash-In Frequency":15,
        "Cash In-Volume (Bn IDR)":0.33,
        "Cash-Out Frequency":78,
        "Cash-Out Volume (Bn IDR)":1.155,
        "Posisi Saldo EOM (Bn IDR)":0.51,
        "Rerata Saldo YTD (Bn IDR)":0.25,
        "% Cash Out BNI vs Cash Out Total":5.2
    },
    {
        "company_name":"PT SINARNIAGA SEJAHTERA",
        "group_company":"GARUDAFOOD",
        "%Closed Loop":1.9,
        "Cash-In Frequency":5,
        "Cash In-Volume (Bn IDR)":0.08,
        "Cash-Out Frequency":85,
        "Cash-Out Volume (Bn IDR)":0.28,
        "Posisi Saldo EOM (Bn IDR)":0.15,
        "Rerata Saldo YTD (Bn IDR)":0.05,
        "% Cash Out BNI vs Cash Out Total":3.2
    },
    {
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "%Closed Loop":3.7,
        "Cash-In Frequency":4,
        "Cash In-Volume (Bn IDR)":38711.0,
        "Cash-Out Frequency":179,
        "Cash-Out Volume (Bn IDR)":135488.5,
        "Posisi Saldo EOM (Bn IDR)":45000.0,
        "Rerata Saldo YTD (Bn IDR)":34532.0,
        "% Cash Out BNI vs Cash Out Total":11.4
    },
    {
        "company_name":"PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)",
        "group_company":"PLN GROUP",
        "%Closed Loop":2.4,
        "Cash-In Frequency":7,
        "Cash In-Volume (Bn IDR)":0.02,
        "Cash-Out Frequency":47,
        "Cash-Out Volume (Bn IDR)":0.07,
        "Posisi Saldo EOM (Bn IDR)":0.06,
        "Rerata Saldo YTD (Bn IDR)":0.01,
        "% Cash Out BNI vs Cash Out Total":7.2
    },
    {
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "%Closed Loop":1.3,
        "Cash-In Frequency":9,
        "Cash In-Volume (Bn IDR)":11015.0,
        "Cash-Out Frequency":135,
        "Cash-Out Volume (Bn IDR)":38552.5,
        "Posisi Saldo EOM (Bn IDR)":13050.0,
        "Rerata Saldo YTD (Bn IDR)":12530.0,
        "% Cash Out BNI vs Cash Out Total":14.5
    },
    {
        "company_name":"PUPUK INDONESIA PERSERO",
        "group_company":"PUPUK INDONESIA",
        "%Closed Loop":2.8,
        "Cash-In Frequency":13,
        "Cash In-Volume (Bn IDR)":17720.0,
        "Cash-Out Frequency":164,
        "Cash-Out Volume (Bn IDR)":62020.0,
        "Posisi Saldo EOM (Bn IDR)":19500.0,
        "Rerata Saldo YTD (Bn IDR)":16850.0,
        "% Cash Out BNI vs Cash Out Total":9.2
    }
]
